import styledMap from 'styled-map';

export enum FontWeight {
	THIN = '100',
	EXTRA_LIGHT = '200',
	LIGHT = '300',
	NORMAL = '400',
	MEDIUM = '500',
	SEMI_BOLD = '600',
	BOLD = '700',
	EXTRA_BOLD = '800',
	ULTRA_BOLD = '900',
}

export const fontWeightMap: Record<FontWeight, number> = {
	[FontWeight.THIN]: 100,
	[FontWeight.EXTRA_LIGHT]: 200,
	[FontWeight.LIGHT]: 300,
	[FontWeight.NORMAL]: 400,
	[FontWeight.MEDIUM]: 500,
	[FontWeight.SEMI_BOLD]: 600,
	[FontWeight.BOLD]: 700,
	[FontWeight.EXTRA_BOLD]: 800,
	[FontWeight.ULTRA_BOLD]: 900,
};
